// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalHeader_header__dDWV5"};